import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Component from './component'
import { push } from 'react-router-redux'
import { loadCustomers } from '../../../ducks/customers'
import {
  loadProjects,
  createProject,
  setProjectStatus,
  setLive,
  copyToBeta,
  updateProject,
  setMaintenanceMode,
} from '../../../ducks/projects'

function mapStateToProps (state, ownProps) { // eslint-disable-line no-unused-vars
  return {
    ...ownProps,
    fetched: state.projects.fetched,
    fetching: state.projects.fetching,
    list: state.projects.list,
    customersFetched: state.customers.fetched,
    customersFetching: state.customers.fetching,
    customers: state.customers.list
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    navigateTo: push,
    loadCustomers,
    loadProjects,
    createProject,
    setProjectStatus,
    setLive,
    copyToBeta,
    updateProject,
    setMaintenanceMode,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Component)



// WEBPACK FOOTER //
// ./ui/projects/list/index.js